module.exports = __webpack_public_path__ + "Gotham-Rounded-Light.1549fe8fd297f1e6501a.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Admin/Documents/Dev Projects/search-artist/src/assets/fonts/Gotham-Rounded-Light.ttf
// module id = ../../../../../src/assets/fonts/Gotham-Rounded-Light.ttf
// module chunks = styles